import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardTitle,
  FormGroup,
  Input,
  Label,
} from "reactstrap";
import { Grid, Typography,
  CircularProgress } from "@mui/material";
import AxiosInstance from "../../AxiosInstance";
import "./style.css";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import * as Yup from "yup";
import {useFormik } from "formik";
import InputText from "../../../components/InputFields/InputText";
import "./style.css";
import BlueButton from "../../../components/Button/BlueButton";
import WhiteButton from "../../../components/Button/WhiteButton";
import showToast from "../../../components/Toast/Toster";
import { useUserType } from "../../../contexts/UserTypeContext";

function AddPermision() {
  const { userType } = useUserType();
  const isDonationMode = userType === "donor";
  const baseUrl = import.meta.env.VITE_BASE_API;
  const location = useLocation();
  const navigate = useNavigate();
  const { CompanyUrl } = useParams();
  const [loader, setLoader] = useState(false);
  const [initialValues, setInitialValues] = useState(null);
  const [submitAttempted, setSubmitAttempted] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      if (location?.state?.id) {
        try {
          const res = await AxiosInstance.get(
            `/v1/permission/${location?.state?.id}`,
            {
              params: {
                PermissionId: location?.state?.id,
              },
            }
          );
          if (res?.data?.data) {
            formFormik.setValues(res?.data?.data);
            setInitialValues(JSON.parse(JSON.stringify(res?.data?.data)));
          }
        } catch (error) {
          console.error("Error fetching permission:", error);
          showToast.error(
            error?.response?.data?.message || "Error fetching permission"
          );
        }
      } else {
        setInitialValues(null);
      }
    };
    fetchData();
  }, [location]);
  const formFormik = useFormik({
    initialValues: {
      Title: "",
      Description: "",
      Schedule: {
        ViewTheirOwnSchedule: false,
        ViewAndCompleteTheirOwnSchedule: false,
        EditTheirOwnSchedule: false,
        EditEveryonesSchedule: false,
        EditAndDeleteEveryonesSchedule: false,
      },
      TimeTrackingAndTimesheets: {
        ViewAndRecordTheirOwn: false,
        ViewRecordAndEditTheirOwn: false,
        ViewRecordAndEditEveryones: false,
      },
      Notes: {
        ViewAllNotes: false,
        ViewAndEditAll: false,
        ViewEditAndDeleteAll: false,
      },
      Expenses: {
        ViewRecordAndEditTheirOwn: false,
        ViewRecordAndEditEveryones: false,
      },
      ShowPricing: {
        AllowsEditingOfQuotesInvoicesAndLineItemsOnJobs: false,
      },
      CustomersProperties: {
        ViewOnly: false,
        ViewCreateAndEdit: false,
        ViewCreateEditAndDelete: false,
      },
      Quotes: {
        ViewOnly: false,
        ViewCreateAndEdit: false,
        ViewCreateEditAndDelete: false,
      },
      Contract: {
        ViewOnly: false,
        ViewCreateAndEdit: false,
        ViewCreateEditAndDelete: false,
      },
      Invoice: {
        ViewOnly: false,
        ViewCreateAndEdit: false,
        ViewCreateEditAndDelete: false,
      },
      MaterialsLabor: {
        ViewOnly: false,
        ViewCreateAndEdit: false,
        ViewCreateEditAndDelete: false,
      },
      Reports: {
        UsersWillOnlyBeAbleToSeeReportsAvailableToThemBasedOnTheirOtherPermissions: false,
      },
    },
    validationSchema: Yup.object({
      Title: Yup.string().required("Title is required."),
      Description: Yup.string().required("Description is required."),
    }),
    validateOnChange: true,
    validateOnBlur: true,
    onSubmit: async (values, { resetForm, setSubmitting, setFieldTouched, validateForm, setErrors }) => {
      setSubmitAttempted(true);
      
      setFieldTouched("Title", true);
      setFieldTouched("Description", true);
      
      await new Promise(resolve => setTimeout(resolve, 0));
      
      const validationErrors = await validateForm();
      
      if (Object.keys(validationErrors).length > 0) {
        setErrors(validationErrors);
        setSubmitting(false);
        return;
      }
      
      // Continue with original submission logic
      if (location?.state?.id) {
        try {
          setLoader(true);
          const response = await AxiosInstance.put(
            `/v1/permission/${location?.state?.id}`,
            {
              ...values,
              PermissionId: location?.state?.id,
            }
          );
          if (response?.data?.statusCode === 200) {
            setTimeout(() => {
              showToast.success(response?.data?.message);
            }, 500);
            setInitialValues(null); // Reset initial values after successful update
            navigate(`/superadmin/permission`, {
              state: {
                navigats: location?.state?.navigats.filter(
                  (item) => item !== "/add-permission"
                ),
              },
            });
          } else {
            setTimeout(() => {
              showToast.error(response?.data?.message);
            }, 500);
          }
        } catch (error) {
          console.error("Error updating permission:", error);
          setTimeout(() => {
            showToast.error(
              error?.response?.data?.message || "Error updating permission"
            );
          }, 500);
        } finally {
          setLoader(false);
        }
      } else {
        try {
          setLoader(true);
          const response = await AxiosInstance.post(
            `/v1/permission`,
            values
          );
          
          if (response?.data.statusCode === 200) {
            setSubmitAttempted(false);
            setTimeout(() => {
              showToast.success(response?.data?.message);
            }, 500);
            navigate(`/superadmin/permission`, {
              state: {
                navigats: location?.state?.navigats.filter(
                  (item) => item !== "/permission"
                ),
              },
            });
            return;
          }

          if (response?.data.statusCode < 500) {
            if (Array.isArray(response?.data?.errors)) {
              response.data.errors.forEach((msg) => showToast.warning(msg));
            } else {
              showToast.warning(response?.data?.message || "Warning occurred");
            }
            return;
          }

          setTimeout(() => {
            showToast.error(response?.data?.message || "An error occurred");
          }, 500);
        } catch (error) {
          if (error?.response) {
            if (error?.response?.data?.statusCode < 500) {
              if (Array.isArray(error?.response?.data?.errors)) {
                error.response.data.errors.forEach((msg) =>
                  showToast.warning(msg)
                );
              } else {
                showToast.warning(
                  error?.response?.data?.message || "Warning occurred"
                );
              }
            } else {
              showToast.error(
                error?.response?.data?.message || "An error occurred"
              );
            }
          } else {
            showToast.error(error?.message || "An error occurred");
          }
        } finally {
          setLoader(false);
        }
      }
    },
  });

  // Check for actual validation errors (not just empty fields)
  const hasErrors = Boolean(
    formFormik?.errors?.Title || 
    formFormik?.errors?.Description
  );
  
  // Check if any field with an error has been touched or submit was attempted
  // Also verify that the value is actually invalid before showing error
  const hasTouchedErrors = Boolean(
    (formFormik?.errors?.Title && (submitAttempted || formFormik?.touched?.Title) && (!formFormik?.values?.Title || String(formFormik?.values?.Title).trim() === "")) ||
    (formFormik?.errors?.Description && (submitAttempted || formFormik?.touched?.Description) && (!formFormik?.values?.Description || String(formFormik?.values?.Description).trim() === ""))
  );
  
  // Only show error message when there are actual validation errors that have been touched or submit attempted
  const shouldShowError = hasTouchedErrors;

  const [checkboxes, setCheckboxes] = useState({
    view: false,
    complete: false,
    editOwn: false,
    editEveryone: false,
    editDeleteEveryone: false,
  });
  const toggleCheckbox = (checkboxName) => {
    setCheckboxes((prevState) => ({
      ...prevState,
      [checkboxName]: !prevState[checkboxName],
    }));
  };
  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    const first = name.split(".")[0];

    if (first === "Schedule") {
      formFormik?.setFieldValue("Schedule.ViewTheirOwnSchedule", false);
      formFormik?.setFieldValue(
        "Schedule.ViewAndCompleteTheirOwnSchedule",
        false
      );
      formFormik?.setFieldValue("Schedule.EditTheirOwnSchedule", false);
      formFormik?.setFieldValue("Schedule.EditEveryonesSchedule", false);
      formFormik?.setFieldValue(
        "Schedule.EditAndDeleteEveryonesSchedule",
        false
      );
    } else if (first === "TimeTrackingAndTimesheets") {
      formFormik?.setFieldValue(
        "TimeTrackingAndTimesheets.ViewAndRecordTheirOwn",
        false
      );
      formFormik?.setFieldValue(
        "TimeTrackingAndTimesheets.ViewRecordAndEditTheirOwn",
        false
      );
      formFormik?.setFieldValue(
        "TimeTrackingAndTimesheets.ViewRecordAndEditEveryones",
        false
      );
    } else if (first === "Notes") {
      formFormik.setFieldValue("Notes.ViewAllNotes", false);
      formFormik.setFieldValue("Notes.ViewAndEditAll", false);
      formFormik.setFieldValue("Notes.ViewEditAndDeleteAll", false);
    } else if (first === "Expenses") {
      formFormik.setFieldValue("Expenses.ViewRecordAndEditTheirOwn", false);
      formFormik.setFieldValue("Expenses.ViewRecordAndEditEveryones", false);
    } else if (first === "ShowPricing") {
      formFormik.setFieldValue(
        "ShowPricing.AllowsEditingOfQuotesInvoicesAndLineItemsOnJobs",
        false
      );
    } else if (first === "CustomersProperties") {
      formFormik.setFieldValue("CustomersProperties.ViewOnly", false);
      formFormik.setFieldValue("CustomersProperties.ViewCreateAndEdit", false);
      formFormik.setFieldValue("CustomersProperties.ViewCreateEditAndDelete", false);
    } else if (first === "Quotes") {
      formFormik.setFieldValue("Quotes.ViewOnly", false);
      formFormik.setFieldValue("Quotes.ViewCreateAndEdit", false);
      formFormik.setFieldValue("Quotes.ViewCreateEditAndDelete", false);
    }else if (first === "Customers") {
      formFormik.setFieldValue("Customers.ViewOnly", false);
      formFormik.setFieldValue("Customers.ViewCreateAndEdit", false);
      formFormik.setFieldValue("Customers.ViewCreateEditAndDelete", false);
    } else if (first === "Contract") {
      formFormik.setFieldValue("Contract.ViewOnly", false);
      formFormik.setFieldValue("Contract.ViewCreateAndEdit", false);
      formFormik.setFieldValue("Contract.ViewCreateEditAndDelete", false);
    } else if (first === "Invoice") {
      formFormik.setFieldValue("Invoice.ViewOnly", false);
      formFormik.setFieldValue("Invoice.ViewCreateAndEdit", false);
      formFormik.setFieldValue("Invoice.ViewCreateEditAndDelete", false);
    } else if (first === "MaterialsLabor") {
      formFormik.setFieldValue("MaterialsLabor.ViewOnly", false);
      formFormik.setFieldValue("MaterialsLabor.ViewCreateAndEdit", false);
      formFormik.setFieldValue("MaterialsLabor.ViewCreateEditAndDelete", false);
    }
    formFormik.setFieldValue(name, checked);
  };

  return (
    <>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          formFormik?.handleSubmit();
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter" && e.target.type !== "submit") {
            e.preventDefault();
          }
        }}
      >
      <Grid className="justify-content-center align-items-center mb-3 mt-5 client">
        <Grid className="d-flex navigatePresetLevel">
          <BlueButton
            isDonationMode={isDonationMode}
            className="customer-details-back-btn"
            aria-label="Go back"
            style={{
              marginRight: "10px",
              width: "44px",
              height: "40px",
              marginBottom: "10px",
              padding: 0,
              borderRadius: "4px",
            }}
            onClick={() => {
              navigate(-1);
            }}
            label={
              <ArrowBackOutlinedIcon sx={{ fontSize: 22, color: "#ffffff" }} />
            }
          />
        </Grid>
        <Card
          className="my-2 col-12 p-4 main-chek border-blue-color"
          style={{ borderRadius: "20px" }}
        >
          <Grid
            style={{ display: "flex", gap: "15px" }}
            className="client-main"
          >
            <Grid
              className="col-lg-6 col-md-6 col-sm-12 text-box"
              style={{ paddingRight: "20px" }}
            >
              <CardTitle
                tag="h5"
                className="text-blue-color"
                style={{
                  fontWeight: 600,
                  display: "flex",
                  alignItems: "center",
                  fontSize: "22px",
                }}
              >
                Preset Permission Levels
              </CardTitle>
              <Grid className="d-flex gap-2 my-4 presetPermissionLevel">
                <Grid className="mb-0">
                  <InputText
                    value={formFormik?.values?.Title}
                    onChange={(e) => {
                      formFormik?.handleChange(e);
                      if (formFormik?.touched?.Title && e.target.value && formFormik?.errors?.Title) {
                        formFormik?.setFieldError("Title", undefined);
                      }
                    }}
                    onBlur={(e) => {
                      formFormik?.handleBlur(e);
                      formFormik?.setFieldTouched("Title", true);
                    }}
                    error={Boolean(formFormik?.errors?.Title && (submitAttempted || formFormik?.touched?.Title))}
                    helperText={undefined}
                    showErrorOnly={true}
                    id="title"
                    name="Title"
                    placeholder="Enter title"
                    label="Title *"
                    type="text"
                    className="mb-2 text-blue-color permissionTitleInput"
                  />
                </Grid>
                <Grid className="mb-0  lastnametxt lastnamemb">
                  <InputText
                    value={formFormik?.values?.Description}
                    onChange={(e) => {
                      formFormik?.handleChange(e);
                      if (formFormik?.touched?.Description && e.target.value && formFormik?.errors?.Description) {
                        formFormik?.setFieldError("Description", undefined);
                      }
                    }}
                    onBlur={(e) => {
                      formFormik?.handleBlur(e);
                      formFormik?.setFieldTouched("Description", true);
                    }}
                    error={Boolean(formFormik?.errors?.Description && (submitAttempted || formFormik?.touched?.Description))}
                    helperText={undefined}
                    showErrorOnly={true}
                    id="description"
                    name="Description"
                    placeholder="Enter description"
                    label="Description *"
                    type="text"
                    className="mb-2 text-blue-color permissionTitleInput presetLevelDesc"
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Card
            style={{
              borderRadius: "15px",
              boxShadow: "var(--shadow-sm)",
            }}
          >
            <CardBody style={{ padding: "30px" }}>
              <Typography
                className="text-blue-color mb-3"
                style={{ fontSize: "18px", fontWeight: 600 }}
              >
                Schedule
              </Typography>
              <Grid className="d-flex gap-2 justify-content-between schedule flexColumnForScheduleAll">
                <FormGroup check>
                  <Input
                    type="checkbox"
                    id="viewCheckbox"
                    name="Schedule.ViewTheirOwnSchedule"
                    checked={formFormik?.values?.Schedule?.ViewTheirOwnSchedule}
                    onChange={handleCheckboxChange}
                  />
                  <Label style={{ cursor: "pointer" }} for="viewCheckbox" check>
                    View their own schedule
                  </Label>
                </FormGroup>
                <FormGroup check>
                  <Input
                    type="checkbox"
                    id="CompleteCheckbox"
                    name="Schedule.ViewAndCompleteTheirOwnSchedule"
                    checked={
                      formFormik?.values?.Schedule
                        ?.ViewAndCompleteTheirOwnSchedule
                    }
                    onChange={handleCheckboxChange}
                  />
                  <Label
                    style={{ cursor: "pointer" }}
                    for="CompleteCheckbox"
                    check
                  >
                    View and complete their own schedule
                  </Label>
                </FormGroup>
                <FormGroup check>
                  <Input
                    type="checkbox"
                    id="EditOwnCheckbox"
                    name="Schedule.EditTheirOwnSchedule"
                    checked={formFormik?.values?.Schedule?.EditTheirOwnSchedule}
                    onChange={handleCheckboxChange}
                  />
                  <Label
                    style={{ cursor: "pointer" }}
                    for="EditOwnCheckbox"
                    check
                  >
                    Edit their own schedule
                  </Label>
                </FormGroup>
                <FormGroup check>
                  <Input
                    type="checkbox"
                    id="EditEveryoneCheckbox"
                    name="Schedule.EditEveryonesSchedule"
                    checked={
                      formFormik?.values?.Schedule?.EditEveryonesSchedule
                    }
                    onChange={handleCheckboxChange}
                  />
                  <Label
                    style={{ cursor: "pointer" }}
                    for="EditEveryoneCheckbox"
                    check
                  >
                    Edit everyone's schedule
                  </Label>
                </FormGroup>
              </Grid>
              <Grid className="d-flex gap-2 justify-content-between mt-4 schedule-last">
                <FormGroup check>
                  <Input
                    type="checkbox"
                    id="DeleteEveryoneCheckbox"
                    name="Schedule.EditAndDeleteEveryonesSchedule"
                    checked={
                      formFormik?.values?.Schedule
                        ?.EditAndDeleteEveryonesSchedule
                    }
                    onChange={handleCheckboxChange}
                  />{" "}
                  <Label
                    style={{ cursor: "pointer" }}
                    for="DeleteEveryoneCheckbox"
                    check
                    onClick={() =>
                      toggleCheckbox("Edit and delete everyone's schedule")
                    }
                  >
                    Edit and delete everyone's schedule
                  </Label>
                </FormGroup>
              </Grid>
            </CardBody>
          </Card>
          <Card
            className="my-3"
            style={{
              borderRadius: "15px",
              boxShadow: "var(--shadow-md)",
            }}
          >
            <CardBody style={{ padding: "30px" }}>
              <Typography
                className="text-blue-color mb-3"
                style={{ fontSize: "18px", fontWeight: 600 }}
              >
                Time Tracking and Timesheets
              </Typography>
              <Grid className="d-flex gap-2 time-tracking justify-content-between flexColumnForScheduleAll">
                <FormGroup check>
                  <Input
                    type="checkbox"
                    id="ViewAndRecordCheckbox"
                    name="TimeTrackingAndTimesheets.ViewAndRecordTheirOwn"
                    checked={
                      formFormik?.values?.TimeTrackingAndTimesheets
                        ?.ViewAndRecordTheirOwn
                    }
                    onChange={handleCheckboxChange}
                  />{" "}
                  <Label
                    style={{ cursor: "pointer" }}
                    for="ViewAndRecordCheckbox"
                    check
                    onClick={() => toggleCheckbox("View and record their own")}
                  >
                    View and record their own timesheet
                  </Label>
                </FormGroup>
                <FormGroup check>
                  <Input
                    type="checkbox"
                    id="ViewRecordCheckbox"
                    name="TimeTrackingAndTimesheets.ViewRecordAndEditTheirOwn"
                    checked={
                      formFormik?.values?.TimeTrackingAndTimesheets
                        ?.ViewRecordAndEditTheirOwn
                    }
                    onChange={handleCheckboxChange}
                  />{" "}
                  <Label
                    style={{ cursor: "pointer" }}
                    for="ViewRecordCheckbox"
                    check
                    onClick={() =>
                      toggleCheckbox("View, record, and edit their own")
                    }
                  >
                    View, record, and edit their own timesheet
                  </Label>
                </FormGroup>
                <FormGroup check>
                  <Input
                    type="checkbox"
                    id="RecordEditEveryoneCheckbox"
                    name="TimeTrackingAndTimesheets.ViewRecordAndEditEveryones"
                    checked={
                      formFormik?.values?.TimeTrackingAndTimesheets
                        ?.ViewRecordAndEditEveryones
                    }
                    onChange={handleCheckboxChange}
                  />{" "}
                  <Label
                    style={{ cursor: "pointer" }}
                    for="RecordEditEveryoneCheckbox"
                    check
                    onClick={() =>
                      toggleCheckbox("View, Record, and Edit Everyone's")
                    }
                  >
                    View, record, and edit everyone's timesheet
                  </Label>
                </FormGroup>
              </Grid>
            </CardBody>
          </Card>
          <Card
            className="my-3"
            style={{
              borderRadius: "15px",
              boxShadow: "var(--shadow-md)",
            }}
          >
            <CardBody style={{ padding: "30px" }}>
              <Typography
                className="text-blue-color mb-3"
                style={{ fontSize: "18px", fontWeight: 600 }}
              >
                Notes
              </Typography>
              <Grid className="d-flex notes gap-2 justify-content-between flexColumnForScheduleAll">
                <FormGroup check>
                  <Input
                    type="checkbox"
                    id="allnotesCheckbox"
                    name="Notes.ViewAllNotes"
                    checked={formFormik?.values?.Notes?.ViewAllNotes}
                    onChange={handleCheckboxChange}
                  />{" "}
                  <Label
                    style={{ cursor: "pointer" }}
                    for="allnotesCheckbox"
                    check
                    onClick={() => toggleCheckbox("View all notes")}
                  >
                    View all notes
                  </Label>
                </FormGroup>
                <FormGroup check>
                  <Input
                    type="checkbox"
                    id="ViewandeditCheckbox"
                    name="Notes.ViewAndEditAll"
                    checked={formFormik?.values?.Notes?.ViewAndEditAll}
                    onChange={handleCheckboxChange}
                  />{" "}
                  <Label
                    style={{ cursor: "pointer" }}
                    for="ViewandeditCheckbox"
                    check
                    onClick={() => toggleCheckbox("View and edit all")}
                  >
                    View and edit all notes
                  </Label>
                </FormGroup>
                <FormGroup check>
                  <Input
                    type="checkbox"
                    id="deleteallCheckbox"
                    name="Notes.ViewEditAndDeleteAll"
                    checked={formFormik?.values?.Notes?.ViewEditAndDeleteAll}
                    onChange={handleCheckboxChange}
                  />{" "}
                  <Label
                    style={{ cursor: "pointer" }}
                    for="deleteallCheckbox"
                    check
                    onClick={() => toggleCheckbox("View, edit, and delete all")}
                  >
                    View, edit, and delete all notes
                  </Label>
                </FormGroup>
              </Grid>
            </CardBody>
          </Card>
          <Card
            className="my-3"
            style={{
              borderRadius: "15px",
              boxShadow: "var(--shadow-md)",
            }}
          >
            <CardBody style={{ padding: "30px" }}>
              <Typography
                className="text-blue-color mb-3"
                style={{ fontSize: "18px", fontWeight: 600 }}
              >
                Expenses
              </Typography>
              <Grid className="d-flex Expenses flexColumnForScheduleAll">
                <FormGroup check>
                  <Input
                    type="checkbox"
                    id="theirownCheckbox"
                    name="Expenses.ViewRecordAndEditTheirOwn"
                    checked={
                      formFormik?.values?.Expenses?.ViewRecordAndEditTheirOwn
                    }
                    onChange={handleCheckboxChange}
                  />{" "}
                  <Label
                    style={{ cursor: "pointer" }}
                    for="theirownCheckbox"
                    check
                    onClick={() =>
                      toggleCheckbox("View, record, and edit their own")
                    }
                  >
                    View, record, and edit their own
                  </Label>
                </FormGroup>
                <FormGroup
                  check
                  className="sec-check expenseSecondLine"
                  style={{ marginLeft: "10.8%" }}
                >
                  <Input
                    type="checkbox"
                    id="andeditCheckbox"
                    name="Expenses.ViewRecordAndEditEveryones"
                    checked={
                      formFormik?.values?.Expenses?.ViewRecordAndEditEveryones
                    }
                    onChange={handleCheckboxChange}
                  />{" "}
                  <Label
                    style={{ cursor: "pointer" }}
                    for="andeditCheckbox"
                    check
                    onClick={() =>
                      toggleCheckbox("View, Record, and Edit Everyone's")
                    }
                  >
                    View, record, and edit everyone's expenses
                  </Label>
                </FormGroup>
              </Grid>
            </CardBody>
          </Card>
          <Card
            className="my-3"
            style={{
              borderRadius: "15px",
              boxShadow: "var(--shadow-md)",
            }}
          >
            <CardBody style={{ padding: "30px" }}>
              <Typography
                className="text-blue-color mb-3"
                style={{ fontSize: "18px", fontWeight: 600 }}
              >
                Show Pricing
              </Typography>
              <Grid className="d-flex gap-2 flexColumnForScheduleAll">
                <FormGroup check>
                  <Input
                    type="checkbox"
                    id="AllowseditingCheckbox"
                    name="ShowPricing.AllowsEditingOfQuotesInvoicesAndLineItemsOnJobs"
                    checked={
                      formFormik?.values?.ShowPricing
                        ?.AllowsEditingOfQuotesInvoicesAndLineItemsOnJobs
                    }
                    onChange={handleCheckboxChange}
                  />{" "}
                  <Label
                    style={{ cursor: "pointer" }}
                    for="AllowseditingCheckbox"
                    check
                    onClick={() =>
                      toggleCheckbox(
                        "Allows editing of quotes, invoices, and line items on contracts."
                      )
                    }
                  >
                    Allows editing of quotes, invoices, and line items on
                    contracts.
                  </Label>
                </FormGroup>
              </Grid>
            </CardBody>
          </Card>
          <Card
            className="my-3"
            style={{
              borderRadius: "15px",
              boxShadow: "var(--shadow-md)",
            }}
          >
            <CardBody style={{ padding: "30px" }}>
              <Typography
                className="text-blue-color mb-3"
                style={{ fontSize: "18px", fontWeight: 600 }}
              >
                Customers and Properties
              </Typography>
              <Grid className="d-flex gap-2 client-check">
                <FormGroup check>
                  <Input
                    type="checkbox"
                    id="addressonlyCheckbox"
                    name="CustomersProperties.ViewOnly"
                    checked={
                      formFormik?.values?.CustomersProperties
                        ?.ViewOnly
                    }
                    onChange={handleCheckboxChange}
                  />{" "}
                  <Label
                    style={{ cursor: "pointer" }}
                    for="addressonlyCheckbox"
                    check
                    onClick={() =>
                      toggleCheckbox("View Only")
                    }
                  >
                   View only
                  </Label>
                </FormGroup>
                <FormGroup check>
                  <Input
                    type="checkbox"
                    id="propertyinfoCheckbox"
                    name="CustomersProperties.ViewCreateAndEdit"
                    checked={
                      formFormik?.values?.CustomersProperties
                        ?.ViewCreateAndEdit
                    }
                    onChange={handleCheckboxChange}
                  />{" "}
                  <Label
                    style={{ cursor: "pointer" }}
                    for="propertyinfoCheckbox"
                    check
                    onClick={() =>
                      toggleCheckbox("View, Create, and Edit")
                    }
                  >
                    View, create, and edit
                  </Label>
                </FormGroup>
                <FormGroup check>
                  <Input
                    type="checkbox"
                    id="fullcustomerCheckbox"
                    name="CustomersProperties.ViewCreateEditAndDelete"
                    checked={
                      formFormik?.values?.CustomersProperties
                        ?.ViewCreateEditAndDelete
                    }
                    onChange={handleCheckboxChange}
                  />{" "}
                  <Label
                    style={{ cursor: "pointer" }}
                    for="fullcustomerCheckbox"
                    check
                    onClick={() =>
                      toggleCheckbox(
                        "View, Create, Edit, and Delete"
                      )
                    }
                  >
                    View, create, edit, and delete
                  </Label>
                </FormGroup>
              </Grid>
            </CardBody>
          </Card>
          <Card
            className="my-3"
            style={{
              borderRadius: "15px",
              boxShadow: "var(--shadow-md)",
            }}
          >
            <CardBody style={{ padding: "30px" }}>
              <Typography
                className="text-blue-color mb-3"
                style={{ fontSize: "18px", fontWeight: 600 }}
              >
                Customers
              </Typography>
              <Grid className="d-flex gap-2 justify-content-between request-check flexColumnForScheduleAll">
                <FormGroup check>
                  <Input
                    type="checkbox"
                    id="customersViewOnlyCheckbox"
                    name="Customers.ViewOnly"
                    checked={formFormik?.values?.Customers?.ViewOnly}
                    onChange={handleCheckboxChange}
                  />{" "}
                  <Label
                    style={{ cursor: "pointer" }}
                    for="customersViewOnlyCheckbox"
                    check
                    onClick={() => toggleCheckbox("View Only")}
                  >
                    View only
                  </Label>
                </FormGroup>
                <FormGroup check>
                  <Input
                    type="checkbox"
                    id="customersViewCreateAndEditCheckbox"
                    name="Customers.ViewCreateAndEdit"
                    checked={formFormik?.values?.Customers?.ViewCreateAndEdit}
                    onChange={handleCheckboxChange}
                  />{" "}
                  <Label
                    style={{ cursor: "pointer" }}
                    for="customersViewCreateAndEditCheckbox"
                    check
                    onClick={() => toggleCheckbox("View, Create, and Edit")}
                  >
                    View, create, and edit
                  </Label>
                </FormGroup>
                <FormGroup check>
                  <Input
                    type="checkbox"
                    id="customersViewCreateEditAndDeleteCheckbox"
                    name="Customers.ViewCreateEditAndDelete"
                    checked={
                      formFormik?.values?.Customers?.ViewCreateEditAndDelete
                    }
                    onChange={handleCheckboxChange}
                  />{" "}
                  <Label
                    style={{ cursor: "pointer" }}
                    for="customersViewCreateEditAndDeleteCheckbox"
                    check
                    onClick={() =>
                      toggleCheckbox("View, Create, Edit, and Delete")
                    }
                  >
                    View, create, edit, and delete
                  </Label>
                </FormGroup>
              </Grid>
            </CardBody>
          </Card>
          <Card
            className="my-3"
            style={{
              borderRadius: "15px",
              boxShadow: "var(--shadow-md)",
            }}
          >
            <CardBody style={{ padding: "30px" }}>
              <Typography
                className="text-blue-color mb-3"
                style={{ fontSize: "18px", fontWeight: 600 }}
              >
                Quotes
              </Typography>
              <Grid className="d-flex gap-2 justify-content-between request-check flexColumnForScheduleAll">
                <FormGroup check>
                  <Input
                    type="checkbox"
                    id="qviewCheckbox"
                    name="Quotes.ViewOnly"
                    checked={formFormik?.values?.Quotes?.ViewOnly}
                    onChange={handleCheckboxChange}
                  />{" "}
                  <Label
                    style={{ cursor: "pointer" }}
                    for="qviewCheckbox"
                    check
                    onClick={() => toggleCheckbox("View Only")}
                  >
                    View only
                  </Label>
                </FormGroup>
                <FormGroup check>
                  <Input
                    type="checkbox"
                    id="qCreateCheckbox"
                    name="Quotes.ViewCreateAndEdit"
                    checked={formFormik?.values?.Quotes?.ViewCreateAndEdit}
                    onChange={handleCheckboxChange}
                  />{" "}
                  <Label
                    style={{ cursor: "pointer" }}
                    for="qCreateCheckbox"
                    check
                    onClick={() => toggleCheckbox("View, Create, and Edit")}
                  >
                    View, create, and edit
                  </Label>
                </FormGroup>
                <FormGroup check>
                  <Input
                    type="checkbox"
                    id="qEditCheckbox"
                    name="Quotes.ViewCreateEditAndDelete"
                    checked={
                      formFormik?.values?.Quotes?.ViewCreateEditAndDelete
                    }
                    onChange={handleCheckboxChange}
                  />{" "}
                  <Label
                    style={{ cursor: "pointer" }}
                    for="qEditCheckbox"
                    check
                    onClick={() =>
                      toggleCheckbox("View, Create, Edit, and Delete")
                    }
                  >
                    View, create, edit, and delete
                  </Label>
                </FormGroup>
              </Grid>
            </CardBody>
          </Card>
          <Card
            className="my-3"
            style={{
              borderRadius: "15px",
              boxShadow: "var(--shadow-md)",
            }}
          >
            <CardBody style={{ padding: "30px" }}>
              <Typography
                className="text-blue-color mb-3"
                style={{ fontSize: "18px", fontWeight: 600 }}
              >
                Contract
              </Typography>
              <Grid className="d-flex gap-2 justify-content-between request-check flexColumnForScheduleAll">
                <FormGroup check>
                  <Input
                    type="checkbox"
                    id="jViewCheckbox"
                    name="Contract.ViewOnly"
                    checked={formFormik?.values?.Contract?.ViewOnly}
                    onChange={handleCheckboxChange}
                  />{" "}
                  <Label
                    style={{ cursor: "pointer" }}
                    for="jViewCheckbox"
                    check
                    onClick={() => toggleCheckbox("View Only")}
                  >
                    View only
                  </Label>
                </FormGroup>
                <FormGroup check>
                  <Input
                    type="checkbox"
                    id="jCreateCheckbox"
                    name="Contract.ViewCreateAndEdit"
                    checked={formFormik?.values?.Contract?.ViewCreateAndEdit}
                    onChange={handleCheckboxChange}
                  />{" "}
                  <Label
                    style={{ cursor: "pointer" }}
                    for="jCreateCheckbox"
                    check
                    onClick={() => toggleCheckbox("View, Create, and Edit")}
                  >
                    View, create, and edit
                  </Label>
                </FormGroup>
                <FormGroup check>
                  <Input
                    type="checkbox"
                    id="jEditCheckbox"
                    name="Contract.ViewCreateEditAndDelete"
                    checked={
                      formFormik?.values?.Contract?.ViewCreateEditAndDelete
                    }
                    onChange={handleCheckboxChange}
                  />{" "}
                  <Label
                    style={{ cursor: "pointer" }}
                    for="jEditCheckbox"
                    check
                    onClick={() =>
                      toggleCheckbox("View, Create, Edit, and Delete")
                    }
                  >
                    View, create, edit, and delete
                  </Label>
                </FormGroup>
              </Grid>
            </CardBody>
          </Card>
          <Card
            className="my-3"
            style={{
              borderRadius: "15px",
              boxShadow: "var(--shadow-md)",
            }}
          >
            <CardBody style={{ padding: "30px" }}>
              <Typography
                className="text-blue-color mb-3"
                style={{ fontSize: "18px", fontWeight: 600 }}
              >
                Invoice
              </Typography>
              <Grid className="d-flex gap-2 justify-content-between request-check flexColumnForScheduleAll">
                <FormGroup check>
                  <Input
                    type="checkbox"
                    id="iViewCheckbox"
                    name="Invoice.ViewOnly"
                    checked={formFormik?.values?.Invoice?.ViewOnly}
                    onChange={handleCheckboxChange}
                  />{" "}
                  <Label
                    style={{ cursor: "pointer" }}
                    for="iViewCheckbox"
                    check
                    onClick={() => toggleCheckbox("View Only")}
                  >
                    View only
                  </Label>
                </FormGroup>
                <FormGroup check>
                  <Input
                    type="checkbox"
                    id="iCreateCheckbox"
                    name="Invoice.ViewCreateAndEdit"
                    checked={formFormik?.values?.Invoice?.ViewCreateAndEdit}
                    onChange={handleCheckboxChange}
                  />{" "}
                  <Label
                    style={{ cursor: "pointer" }}
                    for="iCreateCheckbox"
                    check
                    onClick={() => toggleCheckbox("View, Create, and Edit")}
                  >
                    View, create, and edit
                  </Label>
                </FormGroup>
                <FormGroup check>
                  <Input
                    type="checkbox"
                    id="iEditCheckbox"
                    name="Invoice.ViewCreateEditAndDelete"
                    checked={
                      formFormik?.values?.Invoice?.ViewCreateEditAndDelete
                    }
                    onChange={handleCheckboxChange}
                  />{" "}
                  <Label
                    style={{ cursor: "pointer" }}
                    for="iEditCheckbox"
                    check
                    onClick={() =>
                      toggleCheckbox("View, Create, Edit, and Delete")
                    }
                  >
                    View, create, edit, and delete
                  </Label>
                </FormGroup>
              </Grid>
            </CardBody>
          </Card>
          <Card
            className="my-3"
            style={{
              borderRadius: "15px",
              boxShadow: "var(--shadow-md)",
            }}
          >
            <CardBody style={{ padding: "30px" }}>
              <Typography
                className="text-blue-color mb-3"
                style={{ fontSize: "18px", fontWeight: 600 }}
              >
                Materials & Labor
              </Typography>
              <Grid className="d-flex gap-2 justify-content-between request-check flexColumnForScheduleAll">
                <FormGroup check>
                  <Input
                    type="checkbox"
                    id="mlViewCheckbox"
                    name="MaterialsLabor.ViewOnly"
                    checked={formFormik?.values?.MaterialsLabor?.ViewOnly}
                    onChange={handleCheckboxChange}
                  />{" "}
                  <Label
                    style={{ cursor: "pointer" }}
                    for="mlViewCheckbox"
                    check
                    onClick={() => toggleCheckbox("View Only")}
                  >
                    View only
                  </Label>
                </FormGroup>
                <FormGroup check>
                  <Input
                    type="checkbox"
                    id="mlCreateCheckbox"
                    name="MaterialsLabor.ViewCreateAndEdit"
                    checked={formFormik?.values?.MaterialsLabor?.ViewCreateAndEdit}
                    onChange={handleCheckboxChange}
                  />{" "}
                  <Label
                    style={{ cursor: "pointer" }}
                    for="mlCreateCheckbox"
                    check
                    onClick={() => toggleCheckbox("View, Create, and Edit")}
                  >
                    View, create, and edit
                  </Label>
                </FormGroup>
                <FormGroup check>
                  <Input
                    type="checkbox"
                    id="mlEditCheckbox"
                    name="MaterialsLabor.ViewCreateEditAndDelete"
                    checked={
                      formFormik?.values?.MaterialsLabor?.ViewCreateEditAndDelete
                    }
                    onChange={handleCheckboxChange}
                  />{" "}
                  <Label
                    style={{ cursor: "pointer" }}
                    for="mlEditCheckbox"
                    check
                    onClick={() =>
                      toggleCheckbox("View, Create, Edit, and Delete")
                    }
                  >
                    View, create, edit, and delete
                  </Label>
                </FormGroup>
              </Grid>
            </CardBody>
          </Card>
          <Card
            className="my-3"
            style={{
              borderRadius: "15px",
              boxShadow: "var(--shadow-md)",
            }}
          >
            <CardBody style={{ padding: "30px" }}>
              <Typography
                className="text-blue-color mb-3"
                style={{ fontSize: "18px", fontWeight: 600 }}
              >
                Reports
              </Typography>
              <Grid className="d-flex gap-2 justify-content-between flexColumnForScheduleAll">
                <FormGroup check>
                  <Input
                    type="checkbox"
                    id="UsersCheckbox"
                    name="Reports.UsersWillOnlyBeAbleToSeeReportsAvailableToThemBasedOnTheirOtherPermissions"
                    checked={
                      formFormik?.values?.Reports
                        ?.UsersWillOnlyBeAbleToSeeReportsAvailableToThemBasedOnTheirOtherPermissions
                    }
                    onChange={handleCheckboxChange}
                  />{" "}
                  <Label
                    style={{ cursor: "pointer" }}
                    for="UsersCheckbox"
                    check
                    onClick={() =>
                      toggleCheckbox(
                        "Users will only be able to see reports available to them based on their other permissions."
                      )
                    }
                  >
                    Users can only view reports that match the permissions assigned to them.
                  </Label>
                </FormGroup>
              </Grid>
            </CardBody>
          </Card>
          {shouldShowError && (
            <Grid className="mt-2 mb-2">
              <Typography
                sx={{
                  color: "#dc3545",
                  fontSize: "14px",
                  fontWeight: 500,
                  textAlign: "center",
                }}
              >
                Please correct the red boxes above
              </Typography>
            </Grid>
          )}
          <Grid
            className="d-flex justify-content-between button-responsive BlueAndWhiteBtmFlex permissionbtnHere"
            style={{ marginTop: "70px" }}
          >
            <Grid>
              <WhiteButton 
                onClick={() => {
                  setSubmitAttempted(false);
                  navigate(-1);
                }} 
                label="Cancel" 
              />
            </Grid>
            {loader ? (
              <Grid className="d-flex justify-content-center">
                <CircularProgress size={20} sx={{ color: "#0f2b46" }} />
              </Grid>
            ) : (
              <Grid className="gap-3 d-flex ">
                <BlueButton
                  onClick={() => {
                    formFormik?.handleSubmit();
                  }}
                  disabled={
                    location?.state?.id &&
                    initialValues &&
                    JSON.stringify(formFormik?.values) === JSON.stringify(initialValues)
                  }
                  label={
                    location?.state?.id
                      ? "Update Permission"
                      : "Save Permission"
                  }
                />
              </Grid>
            )}
          </Grid>
        </Card>
      </Grid>
      </form>
    </>
  );
}
export default AddPermision;
